export default {
    PROD: {
        PRINT_HOST: 'https://spad.classba.cn/printapi',
        PRINT_KEY: 'pRtV1p2SArRNOvgpIV8qTjwgBgmO3JYM'
    },
    PRE: {
        PRINT_HOST: 'https://spad-pre.classba.cn/printapi',
        PRINT_KEY: 'pRtV1p2SArRNOvgpIV8qTjwgBgmO3JYM'
    },
    TEST: {
        PRINT_HOST: 'https://spad.test.classba.cn/printapi',
        PRINT_KEY: 'FoQcdQyluQMcsSX046lk70dGeBYqeXEH'
    }
};